'use client';

import { useState } from 'react';

import classnames from 'classnames';

import type { BaseComponentProps } from '../../../base-component.types';
import { DropdownIcon } from '../../../dropdown-icon';
import { SlideDown } from '../../../slide-down';
import { Label } from '../../layout/Label';
import { Title } from '../../layout/Title';
import { ListItem } from '../../list';
import type { AccordionItemType } from '../Accordion.types';

import styles from './AccordionItem.module.scss';

type ContainerProps = BaseComponentProps & {
  item: AccordionItemType;
};

function AccordionItem({
  style,
  className,
  item,
  testId = 'ui-accordion-item',
}: ContainerProps) {
  const [closed, setClosed] = useState(true);

  return (
    <div
      style={style}
      className={classnames(styles['main'], className)}
      data-testid={testId}
    >
      <div
        className={classnames(
          styles['row'],
          item.items && item.items?.length > 0 && styles['row--collapsible'],
        )}
        onClick={() => {
          setClosed(!closed);
        }}
      >
        <div className={styles['wrapper']}>
          {item.label && (
            <Label
              value={item.label.value}
              backgroundColor={item.label.backgroundColor}
            />
          )}
          <Title text={item.text} info={item.info} variant="bold" />
          {item.tag && <div className={styles['tag-wrapper']}>{item.tag}</div>}
        </div>
        {item.items && item.items?.length > 0 && (
          <div className={styles['icon-wrapper']}>
            <DropdownIcon closed={closed} />
          </div>
        )}
      </div>
      <SlideDown className={styles['slide-down']} testId={`${testId}_payload`}>
        {!closed ? (
          <>
            {item.items?.map((item, index) => (
              <ListItem
                className={styles['item']}
                item={item}
                key={index}
                data-testid={`${testId}_payload-${index}`}
              />
            ))}
          </>
        ) : null}
      </SlideDown>
    </div>
  );
}

export { AccordionItem };
